// Reader mode — kills shaders, animations, and ambient motion for pure
// typography. Toggle via the `R` key or the ¶ pill top-right.
//
// Session-scoped: does NOT persist across tabs or reloads. Past versions
// persisted to localStorage, which led to a great Saturday afternoon of
// debugging non-rendering shaders that were actually just hidden by a
// stale reader-mode preference. Never again.

export function initReaderMode(): void {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'reader-toggle';
  btn.setAttribute('aria-label', 'Toggle reader mode');
  btn.setAttribute('aria-pressed', 'false');
  btn.title = 'Reader mode (R)';
  btn.innerHTML = '<span class="reader-toggle-glyph" aria-hidden="true">¶</span>';
  document.body.appendChild(btn);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => btn.classList.add('ready'));
  });

  // One-time migration: clear any legacy persisted reader-mode setting
  // from previous versions. Safe to run forever; no-op once cleared.
  try { localStorage.removeItem('reader-mode'); } catch {}

  btn.addEventListener('click', toggle);
  window.addEventListener('keydown', (e) => {
    if (e.key.toLowerCase() !== 'r' || e.metaKey || e.ctrlKey || e.altKey) return;
    const target = e.target as HTMLElement | null;
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) {
      return;
    }
    toggle();
  });

  function toggle() {
    const next = document.documentElement.dataset.reader === 'on' ? 'off' : 'on';
    if (next === 'on') {
      document.documentElement.dataset.reader = 'on';
    } else {
      delete document.documentElement.dataset.reader;
    }
    btn.setAttribute('aria-pressed', next === 'on' ? 'true' : 'false');
  }
}
